import { space, useNarrowViewport } from '@viq-admin/ui';
import { MetricCard } from './MetricCard';

interface Props {
  repeatVisitors?: number;
  vipCount?: number;
  uniqueScans?: number;
  uniqueCompanies?: number;
}

export function VolumeCoverageStrip({
  repeatVisitors,
  vipCount,
  uniqueScans,
  uniqueCompanies,
}: Props) {
  const narrow = useNarrowViewport();
  return (
    <div
      style={{
        display: 'grid',
        // Same template as KpiTiles, so the two rows' columns line up.
        gridTemplateColumns: `repeat(${narrow ? 2 : 4}, minmax(0, 1fr))`,
        gap: space.md,
        padding: '0 16px 8px',
      }}
    >
      <MetricCard label="Repeat Visitors" value={repeatVisitors} />
      <MetricCard label="VIP Count" value={vipCount} />
      <MetricCard label="Unique Scans" value={uniqueScans} />
      <MetricCard label="Unique Companies" value={uniqueCompanies} />
    </div>
  );
}
